import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { getEnquiries, getUsers, getPrograms, getPlans } from '../data/mockData';
import Tabs from '../components/shared/Tabs';
import FloatingActionButton from '../components/shared/FloatingActionButton';
import EnquiriesTab from '../components/enquiries/EnquiriesTab';
import AddEnquiryModal from '../components/enquiries/AddEnquiryModal';
import FollowUpTrackerTab from '../components/enquiries/FollowUpTrackerTab';
import ConversionAnalyticsTab from '../components/enquiries/ConversionAnalyticsTab';
import FollowUpModal from '../components/enquiries/FollowUpModal';
import ConvertModal from '../components/enquiries/ConvertModal';
import ConfirmationDialog from '../components/shared/ConfirmationDialog';
import MemberRegistrationWizard from '../components/registration/MemberRegistrationWizard';
import useDidFetch from '../custom_hooks/useDidfetch';
import api from '../services/ApiService';
import { ENDPOINTS } from '../constant/ApiEndpoints';
import EnquiryDetailModal from '../components/enquiries/EnquireDetailModal';
import { cleanObject } from '../components/CleanObject';

const EnquiryManagementPage = () => {
    const [enquiries, setEnquiries] = useState([]);
    const [followups, setFollowups] = useState([]);
    const [trainers, setTrainers] = useState([]);
    const [plans, setPlans] = useState([]);
    const navigate = useNavigate();

    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isFollowUpModalOpen, setIsFollowUpModalOpen] = useState(false);
    const [isConvertModalOpen, setIsConvertModalOpen] = useState(false);
    const [isEnquiryDetailModalOpen, setIsEnquiryDetailModalOpen] = useState(false);
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const [isWizardOpen, setIsWizardOpen] = useState(false);

    const [activeEnquiry, setActiveEnquiry] = useState(null);
    const [enqData, setEnqData] = useState(null);
    const [conversionData, setConversionData] = useState(null);
    const [actionToConfirm, setActionToConfirm] = useState(null);
    const [loader, setLoader] = useState({
        "followup_btn": false,
        "member_create": false
    });

    const programs = getPrograms();
    const ruOnce = useDidFetch();
    useEffect(() => {
        ruOnce(() => {
            getEnquiriesList();
            getTrainers();
            // getFollowupList();
            getAllPlans();
        })
    }, []);

    useEffect(() => {
        const followupList = enquiries.filter((enq) => enq.status != 'converted');
        setFollowups(followupList);
    }, [enquiries])

    const getAllPlans = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(ENDPOINTS.getPlan);
            const result = response?.data;
            console.log(response);
            if (response.status === 200 || response.status === 201) {
                setPlans(result ?? []);
            }
        } catch (error) {
            console.error("plans get error:", error);
        }
    }

    const getTrainers = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(`${ENDPOINTS.getUserByRole}/trainer`);
            const result = response?.data;
            console.log(response);
            if (response.status === 200) {
                setTrainers(result?.users ?? []);
            } else {
                toast.error(result?.message || "Login failed!");
            }
        } catch (error) {
            console.error("user get error:", error);
        }
    }

    // const getFollowupList = async () => {
    //     try {
    //         let response = await api.get(ENDPOINTS.getFollowups);
    //         let result = response?.data;
    //         if (response?.status == 200 || response?.status == 201) {
    //             setFollowups(result ?? []);
    //         }
    //     } catch (error) {
    //         console.log("get Followups Error", error);
    //     }
    // }
    const getEnquiriesList = async () => {
        try {
            let response = await api.get(ENDPOINTS.getEnquiries);
            let result = response?.data;
            if (response?.status == 200 || response?.status == 201) {
                setEnquiries(result ?? []);
            }
        } catch (error) {
            console.log("get Enquiries Error", error);
        }
    }

    const handleAddEnquiry = () => setIsAddModalOpen(true);

    const handleScheduleFollowUp = (enquiry) => {
        console.log(enquiry);
        setActiveEnquiry(enquiry);
        setIsFollowUpModalOpen(true);
    };

    const handleConvertToMember = (enquiry) => {
        setEnqData({
            enq_id: enquiry?.id,
            id: enquiry?.user_id,
            name: enquiry?.user_name,
            contact: enquiry?.phone,
            status: enquiry?.status,
            source: enquiry?.source,
            assigned_to: enquiry?.assigned_to,
            email: enquiry?.email
        });
        setActiveEnquiry(enquiry);
        setIsConvertModalOpen(true);
    };

    const handleOpenEnquiryView = (enquiry) => {
        setActiveEnquiry(enquiry);
        setIsEnquiryDetailModalOpen(true)
    }

    const handleSaveEnquiry = async (enquiryData) => {
        console.log(enquiryData);

        try {
            let response = await api.post(ENDPOINTS.saveEnquiry, enquiryData);
            let result = response?.data;
            if (response?.status == 200 || response?.status == 201) {
                setIsAddModalOpen(false);
                toast.success('Enquiry saved successfully.');
                getEnquiriesList();
            }
        } catch (error) {
            console.log("save enquiry error", error);
        }
    };

    const handleSaveFollowUp = async (followUpData) => {
        console.log(followUpData);
        try {
            setLoader(prev => ({ ...prev, followup_btn: true }))
            let response = await api.post(ENDPOINTS.saveFollowup, followUpData);
            let result = response?.data;
            if (response?.status == 200 || response?.status == 201) {
                setIsFollowUpModalOpen(false);
                setActiveEnquiry(null);
                toast.success('Follow-up scheduled successfully.');
                getEnquiriesList();
            }
        } catch (error) {
            console.log("followup error", error);
        } finally {
            setLoader(prev => ({ ...prev, followup_btn: false }))
        }
    };

    const handleSaveConversion = (data) => {
        setConversionData(data);
        setIsConvertModalOpen(false);
        setIsWizardOpen(true); // Open the registration wizard
    };

    const handleRegistrationSuccess = async (newMember) => {
        console.log(newMember);

        let trainerId = parseInt(newMember?.membership?.assignedTrainer ?? '0');
        let plan_id = parseInt(newMember?.membership?.planId ?? '0');

        let memberData = {
            //personal
            "name": newMember?.personal?.name,
            "email": newMember?.personal?.email,
            "phone": newMember?.personal?.contact,
            "dob": newMember?.personal?.dob,
            "gender": newMember?.personal?.gender,
            "emergency_contact_name": newMember?.personal?.emergencyContactName,
            "emergency_contact_number": newMember?.personal?.emergencyContactPhone,
            "address": newMember?.personal?.address,
            //health
            "height_cm": newMember?.health?.height,
            "weight_kg": newMember?.health?.weight,
            "fitness_level": newMember?.health?.level,
            "medical_conditions": newMember?.health?.conditions,
            "fitness_goals": newMember?.health?.goals,
            //membership
            "role_id": 3,
            "role": 3,
            "trainer_assigned": trainerId,
            "plan_id": plan_id,
            "image_base64": newMember?.personal?.image_base64,
            "start_date": newMember?.membership?.startDate,            
            "end_date": newMember?.membership?.endDate, 
            "status": newMember?.membership?.userStatus,
            "converted_from_enquiry": 1,
        }
        let obj = cleanObject(memberData)
        try {
            setLoader(prev => ({ ...prev, member_create: true }));
            const response = await api.put(`${ENDPOINTS.updateUser}/${newMember?.id}`, obj);
            const result = response?.data;
            console.log(response);
            if (response?.status == 200 || response?.status == 201) {
                toast.success(result?.message ?? "Member added Successfully");
                updateEnquiry(newMember?.enq_id, newMember?.personal?.name);
            }
        } catch (error) {
            console.log("new member registration", error);
            setLoader(prev => ({ ...prev, member_create: false }));
        }
    };

    const updateEnquiry = async (enqId, membername) => {
        let obj = {
            "status": "converted"
        }
        try {
            const response = await api.put(`${ENDPOINTS.convertEnquiry}/${enqId}`, obj);
            const result = response?.data;
            if (response?.status == 200 || response?.status == 201) {
                toast.success(`Member ${membername} Converted successfully!`);
                setIsWizardOpen(false);
                setActiveEnquiry(null);
                setConversionData(null);
                getEnquiriesList()
            }
        } catch (error) {
            console.log("member converted error", error);
        } finally {
            setLoader(prev => ({ ...prev, member_create: false }));
        }
    }

    const confirmAction = () => {
        if (actionToConfirm === 'delete') {
            setEnquiries(enquiries.filter(enq => enq.id !== activeEnquiry.id));
            toast.success('Enquiry deleted successfully.');
        }
        setIsConfirmOpen(false);
        setActiveEnquiry(null);
        setActionToConfirm(null);
    };

    const tabs = [
        { label: 'All Enquiries', content: <EnquiriesTab enquiries={enquiries} onSchedule={handleScheduleFollowUp} onConvert={handleConvertToMember} onOpenDetail={handleOpenEnquiryView} /> },
        { label: 'Follow-up Tracker', content: <FollowUpTrackerTab enquiries={enquiries} onSchedule={handleScheduleFollowUp} onOpenDetail={handleOpenEnquiryView} /> },
        // { label: 'Conversion Analytics', content: <ConversionAnalyticsTab enquiries={enquiries} /> },
    ];

    return (
        <>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="space-y-6"
            >
                <h1 className="text-3xl font-bold font-display text-gray-800">Enquiry Management</h1>
                <Tabs tabs={tabs} />

                <FloatingActionButton onClick={handleAddEnquiry}>
                    <Plus size={24} />
                </FloatingActionButton>
            </motion.div>

            <AddEnquiryModal
                isOpen={isAddModalOpen}
                onClose={() => setIsAddModalOpen(false)}
                onSave={handleSaveEnquiry}
                trainers={trainers}
                programs={programs}
            />
            <EnquiryDetailModal
                isOpen={isEnquiryDetailModalOpen}
                onClose={() => setIsEnquiryDetailModalOpen(false)}
                enquiry={activeEnquiry}
            />
            <FollowUpModal
                isOpen={isFollowUpModalOpen}
                onClose={() => setIsFollowUpModalOpen(false)}
                onSave={handleSaveFollowUp}
                enquiry={activeEnquiry}
                isFollowLoading={loader.followup_btn}
            />

            <ConvertModal
                isOpen={isConvertModalOpen}
                onClose={() => setIsConvertModalOpen(false)}
                onSave={handleSaveConversion}
                enquiry={activeEnquiry}
                plans={plans}
            />

            <ConfirmationDialog
                isOpen={isConfirmOpen}
                onClose={() => setIsConfirmOpen(false)}
                onConfirm={confirmAction}
                title="Confirm Deletion"
                description={`Are you sure you want to delete the enquiry for "${activeEnquiry?.user_name}"?`}
            />

            <MemberRegistrationWizard
                isLoading={loader.member_create}
                isOpen={isWizardOpen}
                onClose={() => setIsWizardOpen(false)}
                onSuccess={handleRegistrationSuccess}
                initialData={enqData}
                conversionData={conversionData}
            />
        </>
    );
};

export default EnquiryManagementPage;
